import { all, call, fork, put, takeEvery } from "redux-saga/effects";
// Include call API
import { getUsersAPI } from "../../../api/users";
import { apiError, logoutUserSuccess } from "./actions";
// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";



const usersAPI = getUsersAPI();

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(usersAPI.login, user.name, user.pass);
    let user_response = { ...response.user };
    if(user_response.role_id <= 3){
      localStorage.setItem("authUser", JSON.stringify(user_response));
      yield put(logoutUserSuccess(response.user));
      history.push("/dashboard")
      // if(user_response.role_id <= 2) history.push("/tasks");
      // else history.push("/dashboard")
    }else{
      yield put(apiError("Role invalid"));
    }
   
  } catch (error) {
    yield put(apiError(error.message));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    history.push("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchUserLogin() {
  yield takeEvery(LOGIN_USER, loginUser);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}

function* authSaga() {
  yield all([fork(watchUserLogin), fork(watchUserLogout)]);
}

export default authSaga;
